import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, nextTick, onBeforeMount, ref } from 'vue';
import CButton from '@/components/shared/CButton';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableText',
  props: {
    value: null,
    defaultText: { default: '' },
    allowEditing: { type: Boolean, default: true },
    tooltipDirection: { default: 'top' },
    tooltip: { default: 'Rename' },
    label: { default: '' },
    type: { default: 'search' },
    preventClick: { type: Boolean, default: false },
    preventEmptyValue: { type: Boolean },
    renameBtn: { type: Boolean, default: true }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, defaultText: string, allowEditing: boolean, tooltipDirection: string, tooltip: string, label: string, type: string, preventClick: boolean, preventEmptyValue?: boolean, renameBtn: boolean };





const editMode = ref(false);
const inputValue = ref('');

const editableInputRef: Ref<HTMLInputElement | null> = ref(null);

const tooltipOptions = computed(() => {
    const options: Record<string, unknown> = { placement: props.tooltipDirection, interactive: false };
    if (!props.tooltip.length) {
        options.trigger = '';
    }
    return options;
});

const text = computed({
    get(): string | number {
        return props.value;
    },
    set(value: string | number) {
        inputValue.value = value as string;
        emit('input', value);
    }
});

onBeforeMount(() => {
    inputValue.value = text.value as string;
});

const enterTitleEditMode = (event: MouseEvent) => {
    if (!props.allowEditing) return;
    /**
     * Add a small delay before entering edit mode so event listener that fire
     * due to click events have an opportunity to run.
     */
    event.stopPropagation();
    setTimeout(() => {
        editMode.value = true;
        inputValue.value = text.value as string;

        nextTick().then(() => {
            editableInputRef.value?.focus();
        });

        event.stopImmediatePropagation();
        event.preventDefault();
    }, 20);
};

const onFocusLost = () => {
    inputValue.value = props.preventEmptyValue && !inputValue.value?.length ? String(text.value) : inputValue.value;
    if (editMode.value && inputValue.value !== text.value) {
        text.value = inputValue.value;
    }
    editMode.value = false;
};

const onTextInputKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && editMode.value) {
        // Exit edit mode on enter and trigger the change event
        event.preventDefault();
        event.stopPropagation();

        onFocusLost();
    } else if (editMode.value && (event.key === 'Escape' || event.key === 'Esc')) {
        // Exit without triggering a change event
        event.preventDefault();
        event.stopPropagation();
        editMode.value = false;
    }
    event.stopImmediatePropagation();
};

const preventOnClick = (event: MouseEvent) => {
    if (props.preventClick) {
        event.stopImmediatePropagation();
    }
};

const handleDblClick = (event: MouseEvent) => {
    if (props.allowEditing) {
        enterTitleEditMode(event);
    }
};

return { __sfc: true,emit, props, editMode, inputValue, editableInputRef, tooltipOptions, text, enterTitleEditMode, onFocusLost, onTextInputKeyDown, preventOnClick, handleDblClick, CButton }
}

})